<template lang="html">
	<div class="editor-page">
		<div class="content_btn editor-btn">
			<div class="content_btn_item">
				<h5>{{title}}:详情编辑</h5>
				<button class="pre_btn_ok" @click="fun_save('go_back')">
					返回
				</button>
				<button class="btn_add" @click="fun_save">
					保存详情
				</button>
				<button class="pre_btn_ok btn_del" @click="fun_del">
					删除详情
				</button>
				<label v-show="show_file">文件:</label><span v-show="show_file">{{file_up}}</span>
			</div>
		</div>

		<div id="toolbar-container" class="toolbar" v-loading="element_loading" element-loading-text="拼命加载中......"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
		<div id="text-container" class="edit-body"></div>


	</div>
</template>


<script>
	// npm i wangeditor --save 4.7版本

	import E from 'wangeditor';

	import api from '@/utils/type.js';

	import {
		base_encode,
		base_decode
	} from '@/utils/base64.js';

	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial
	} from "@/utils/localstore.js";

	import {
		Method_SelColumn,
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';

	export default {
		name: 'editoritem',
		data() {
			return {
				element_loading: false,
				editor: null,
				info_: null,
				fullloading: false,
				delete_file: [],

				list_save_file: [],

				show_file: false,
				title: '',
				main_id: '',
				sheet_no: '',
				file_name: "",
				file_type: '',
				file_size: '',
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_action: '',
				blockSize: '',
				p1: '',
				p2: '',
				p3: '',

				file_time: ''
			}
		},
		methods: {
			init: function(parm) {
				// console.log(parm);
				this.title = parm.title;
				this.main_id = parm.main_id;
				this.sheet_no = parm.sheet_no;
				this.file_action = parm.file_action;

				// 如果 sheet_no是空，add 2022-10-31
				console.log('详情编辑 sheet_no=' + this.sheet_no + ' main_id=' + this.main_id);
				if (String(this.sheet_no) == 'undefined' || String(this.sheet_no) == '') {
					this.sheet_no = this.main_id;
				}

				this.p1 = parm.p1;

				// console.log('main_id=' + this.main_id);
				// console.log('sheet_no=' + this.sheet_no);

				// let date = new Date();
				// var y = date.getFullYear();
				// var m = date.getMonth() + 1;
				// m = m < 10 ? ('0' + m) : m;
				// var d = date.getDate();
				// d = d < 10 ? ('0' + d) : d;
				// // var h = date.getHours();
				// // h = h < 10 ? ('0' + h) : h;
				// // var minute = date.getMinutes();
				// // minute = minute < 10 ? ('0' + minute) : minute;
				// // this.file_time = y + '' + m + '' + d + '' + h + '' + m;
				// // this.p3 = time;
				// this.p2 = y + '' + m + '' + d;
				this.p2 = parm.p2;
				this.p3 = parm.p3;

				this.blockSize = 1 * 1024 * 1024; //单块标准2M

				this.file_name = '';
				this.file_up = '';


				// this.list_mp4 = [];
				// this.list_img = [];
				this.seteditor();
			},
			init_pagedata: function() {
				this.$post(
					api.http_method, Method_SelColumn('page_main_' + this.file_action, this.main_id, this.sheet_no)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					// console.log(res.data);
					if (typeof(res.data) !== 'undefined' && res.data != '' && res.data.status != '0') {
						console.log(res);
						let ok_html = base_decode(res.data);
						// console.log(ok_html);
						ok_html = base_decode(ok_html);
						// console.log(ok_html);

						if (ok_html != '') {
							this.editor.txt.html(ok_html);
						}


					}
				});
			},
			seteditor() {
				this.editor = new E('#toolbar-container', '#text-container') // 传入两个元素

				// let screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// screenHeight = screenHeight - 180;
				// this.editor.config.height = screenHeight+'px'; // 设置编辑区域高度为 500px
				this.editor.config.pasteFilterStyle = false; // 来关闭样式过滤
				this.editor.config.pasteIgnoreImg = true; // 忽略粘贴的图片

				// 配置菜单栏，删减菜单，调整顺序
				this.editor.config.menus = [
					'head', // 标题
					'bold', // 粗体
					'fontSize', // 字号
					'fontName', // 字体
					'italic', // 斜体
					'underline', // 下划线
					'strikeThrough', // 删除线
					'foreColor', // 文字颜色
					'backColor', // 背景颜色
					'link', // 插入链接
					'list', // 列表
					'justify', // 对齐方式
					'quote', // 引用
					'emoticon', // 表情
					'image', // 插入图片
					'table', // 表格
					'video', // 插入视频
					// 'code', // 插入代码
					'undo', // 撤销
					'redo', // 重复
					'fullscreen' // 全屏
				];

				// 配置颜色（文字颜色、背景色）
				this.editor.config.colors = [
					"#FFFFFF", "#DDDDDD", "#AAAAAA", "#888888", "#666666",
					"#444444", "#000000", "#FFB7DD", "#FF88C2", "#FF44AA", "#FF0088", "#C10066",
					"#A20055", "#8C0044", "#FFCCCC", "#FF8888", "#FF3333", "#FF0000", "#CC0000",
					"#AA0000", "#880000", "#FFC8B4", "#FFA488", "#FF7744", "#FF5511", "#E63F00",
					"#C63300", "#A42D00", "#FFDDAA", "#FFBB66", "#FFAA33", "#FF8800", "#EE7700",
					"#CC6600", "#BB5500", "#FFEE99", "#FFDD55", "#FFCC22", "#FFBB00", "#DDAA00",
					"#AA7700", "#886600", "#FFFFBB", "#FFFF77", "#FFFF33", "#FFFF00", "#EEEE00",
					"#BBBB00", "#888800", "#EEFFBB", "#DDFF77", "#CCFF33", "#BBFF00", "#99DD00",
					"#88AA00", "#668800", "#CCFF99", "#BBFF66", "#99FF33", "#77FF00", "#66DD00",
					"#55AA00", "#227700", "#99FF99", "#66FF66", "#33FF33", "#00FF00", "#00DD00",
					"#00AA00", "#008800",
					"#BBFFEE", "#77FFCC", "#33FFAA", "#00FF99", "#00DD77", "#00AA55", "#008844",
					"#AAFFEE", "#77FFEE", "#33FFDD", "#00FFCC", "#00DDAA", "#00AA88", "#008866",
					"#99FFFF", "#66FFFF", "#33FFFF", "#00FFFF", "#00DDDD", "#00AAAA", "#008888",
					"#CCEEFF", "#77DDFF", "#33CCFF", "#00BBFF", "#009FCC", "#0088A8", "#007799",
					"#CCDDFF", "#99BBFF", "#5599FF", "#0066FF", "#0044BB", "#003C9D", "#003377",
					"#CCCCFF", "#9999FF", "#5555FF", "#0000FF", "#0000CC", "#0000AA", "#000088",
					"#CCBBFF", "#9F88FF", "#7744FF", "#5500FF", "#4400CC", "#2200AA", "#220088",
					"#D1BBFF", "#B088FF", "#9955FF", "#7700FF", "#5500DD", "#4400B3", "#3A0088",
					"#E8CCFF", "#D28EFF", "#B94FFF", "#9900FF", "#7700BB", "#66009D", "#550088",
					"#F0BBFF", "#E38EFF", "#E93EFF", "#CC00FF", "#A500CC", "#7A0099", "#660077",
					"#FFB3FF", "#FF77FF", "#FF3EFF", "#FF00FF", "#CC00CC", "#990099", "#770077"
				];

				// 配置字体
				// this.editor.config.fontNames = [
				//     // 对象形式 v4.6.16
				//     {name:"黑体",value:"黑体"},
				//     {name:"绝绝字体",value:"Times New Roman"}
				//     // 字符串形式
				//     '黑体',
				//     '仿宋',
				//     '楷体',
				//     '标楷体',
				//     '华文仿宋',
				//     '华文楷体',
				//     '宋体',
				//     '微软雅黑',
				//     'Arial',
				//     'Tahoma',
				//     'Verdana',
				//     'Times New Roman',
				//     'Courier New',
				// ]

				// 配置行高
				this.editor.config.lineHeights = ['1', '1.15', '1.6', '2', '2.5', '3']

				// npm install highlight.js -S
				// 挂载highlight插件 配合代码高亮模式
				// editor.highlight = hljs
				//插入代码语言配置
				// this.editor.config.languageType = [
				//     'Bash',
				//     'C',
				//     'C#',
				//     'C++',
				//     'CSS',
				//     'Java',
				//     'JavaScript',
				//     'JSON',
				//     'TypeScript',
				//     'Plain text',
				//     'Html',
				//     'XML',
				//     'SQL',
				//     'Go',
				//     'Kotlin',
				//     'Lua',
				//     'Markdown',
				//     'PHP',
				//     'Python',
				//     'Shell Session',
				//     'Ruby',
				// ]

				var that = this;
				// 配置 onchange 回调函数
				this.editor.config.onchange = function(newHtml) {
					// console.log('change 之后最新的 html', newHtml)

				}
				// 配置触发 onchange 的时间频率，默认为 200ms
				this.editor.config.onchangeTimeout = 3000; // 修改为 500ms

				this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 2M
				this.editor.config.showLinkImg = false; //隐藏插入网络图片的功能，即只保留上传本地图片
				this.editor.config.uploadImgShowBase64 = false // base 64 存储图片
				this.editor.config.uploadImgMaxLength = 1; // 一次最多上传 5 个图片
				// uploadImgShowBase64（base64 格式）和 uploadImgServer（上传图片到服务器）两者不能同时使用
				// 采用自定义上传图片方法
				this.editor.config.customUploadImg = async function(files, insertImgFn) {
					// console.log(files[0]);
					// resultFiles 是 input 中选中的文件列表
					// insertImgFn 是获取图片 url 后，插入到编辑器的方法
					// 上传图片，返回结果，将图片插入到编辑器中
					// insertImgFn(imgUrl)
					let res = await that.fun_up_file_max(files[0]);

					if (res.data.status == 1) {
						that.$message({
							message: '上传成功!',
							type: 'success'
						});
						// console.log(res.data);
						let temp_url = '';
						temp_url = BackSpecial(res.data.f_url);

						// let o = {};
						// o.id = res.data.new_id;
						// o.f_url = temp_url;
						// o.f_src = BackSpecial(res.data.f_src);
						// that.list_img.push(o);
						// console.log(temp_url);
						insertImgFn(temp_url); //插入到界面
					} else {
						that.$message({
							message: '上传失败!',
							type: 'warning'
						});
					}

				}

				this.editor.config.uploadVideoMaxSize = 20 * 1024 * 1024 // 20m
				this.editor.config.uploadVideoAccept = ['mp4'];
				this.editor.config.uploadVideoTimeout = 1000 * 60 * 5; //上传接口等待的最大时间，默认是 5分钟
				this.editor.config.customUploadVideo = async function(resultFiles, insertVideoFn) {
					// resultFiles 是 input 中选中的文件列表
					// insertVideoFn 是获取视频 url 后，插入到编辑器的方法
					// console.log(resultFiles);
					// 上传视频，返回结果，将视频地址插入到编辑器中
					// insertVideoFn(videoUrl)
					let res = await that.fun_up_file_max(resultFiles[0]);

					if (res.data.status == 1) {
						that.$message({
							message: '上传成功!',
							type: 'success'
						});
						// console.log(res.data);
						let temp_url = '';
						temp_url = BackSpecial(res.data.f_url);

						// let o = {};
						// o.id = res.data.new_id;
						// o.f_url = temp_url;
						// o.f_src = BackSpecial(res.data.f_src);
						// that.list_mp4.push(o);
						// console.log(temp_url);
						insertVideoFn(temp_url); //插入到界面
					} else {
						that.$message({
							message: '上传失败!',
							type: 'warning'
						});
					}
				}

				// 配置粘贴文本的内容处理
				this.editor.config.pasteTextHandle = function(pasteStr) {
					// 对粘贴的文本进行处理，然后返回处理后的结果
					return pasteStr
				}
				// 配置全屏功能按钮是否展示
				this.editor.config.showFullScreen = true;

				// 自定义检查插入的链接
				this.editor.config.linkCheck = function(text, link) {
					console.log(text);
					console.log(link);
					// 以下情况，请三选一
					// 1. 返回 true ，说明检查通过
					return true
					// // 2. 返回一个字符串，说明检查未通过，编辑器会阻止链接插入。会 alert 出错误信息（即返回的字符串）
					// return '链接有 xxx 错误'
					// 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止链接插入。
					// 此处，你可以自定义提示错误信息，自由发挥
				}

				this.editor.create();

				this.init_pagedata();
			},
			fun_check: async function() {
				let imgReg = /<img.*?(?:>|\/>)/gi //匹配图片中的img标签
				let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src
				let str = this.editor.txt.html();
				let arr = str.match(imgReg); //筛选出所有的img
				let srcArr = [];
				// console.log(typeof(arr));
				try {
					for (let i = 0; i < arr.length; i++) {
						let src = arr[i].match(srcReg)
						// // 获取图片地址
						console.log('在线图片',src)
						srcArr.push(src[1]);
					}

					// 找出删除的图片
					for (let i = 0; i < this.list_save_file.length; i++) {
						let is_del = true;
						for (let j = 0; j < srcArr.length; j++) {
							if (this.list_save_file[i].f_url == srcArr[j]) {
								is_del = false;
								break;
							}
						}
						if (is_del) {
							await this.fun_del_file(this.list_save_file[i]);

						}
					}


				} catch (err) {

				}

			},
			fun_check_mp4: async function() {

				let imgReg = /<video.*?(?:>|\/>)/gi //匹配图片中的img标签
				let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src
				let str = this.editor.txt.html();
				// console.log(str)
				let arr = str.match(imgReg); //筛选出所有的img
				let srcArr = [];
				// console.log(typeof(arr));
				try {
					for (let i = 0; i < arr.length; i++) {
						let src = arr[i].match(srcReg)
						// // 获取图片地址
						// console.log(src)
						srcArr.push(src[1]);
					}

					// console.log('页面文件数量='+srcArr.length);
					// console.log('加载文件数量='+this.list_save_file.length);
					for (let i = 0; i < this.list_save_file.length; i++) {
						let is_del = true;
						for (let j = 0; j < srcArr.length; j++) {
							if (this.list_save_file[i].f_url == srcArr[i]) {
								is_del = false;
								break;
							}
						}
						if (is_del) {
							// console.log('删除路径='+this.list_save_file[i].f_src);
							await this.fun_del_file(this.list_save_file[i]);
						}
					}

				} catch (err) {

				}

			},
			load_save_flie: function() {
				let that = this;
				return new Promise((resolve, reject) => {
					that.$post(
						api.http_method, Sel_page_and_length('exp_page_allsave_' + this.file_action, 1,
							999, that.sheet_no)
					).then(res => {
						res = JSON.parse(res);
						// console.log('历史保存文件='+res.length);
						// console.log('历史保存文件=',res);
						let list = [];
						if (res.length<=1){
							list = res[0];
						}else{
							let res_page = [];
							res_page = res[0][0];
							let all_count = res_page.all_count;
							
							if (all_count > 0) {
								// console.log(res[1]);
								list = res[1];
							}
						}
						
						resolve(list)
					});

				});
			},
			fun_save: async function(type) {
				// console.log(this.editor)
				if (typeof(this.editor) === 'undefined' || typeof(this.editor) === null || this.editor == null) {
					this.$emit('book-event');
					return;
				}

				// let page_json = {};
				// page_json = this.editor.txt.getJSON();
				// console.log('123保存详情。。。。。。。');
				// 保存前检查一次 文件的保存记录。保证把多余都删了

				this.list_save_file = [];
				this.list_save_file = await this.load_save_flie();
				console.log('已保存文件',this.list_save_file)
				if (typeof(this.list_save_file)!=='undefined' && this.list_save_file.length > 0) {
					// console.log('00临时文件数量=' + this.list_save_file.length);
					await this.fun_check();
					await this.fun_check_mp4();
				}

				if (type == 'go_back' && this.editor.txt.html() == '') {
					if (typeof(this.editor) !== 'undefined' && this.editor != null) {
						this.editor.destroy();
						this.editor = null;
					}
					this.$emit('book-event');
					return;
				}

				let postdata =
					'{"action":"' + 'data_savehtml_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.title +
					'","upfile_data":"' +
					base_encode(this.editor.txt.html()) +
					'","rowid":"' +
					this.main_id +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';
				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"Page_Action","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == '1') {
						console.log(res.data);
						this.$message({
							type: 'success',
							message: res.data.msg
						});

						if (type == 'go_back') {
							if (typeof(this.editor) !== 'undefined' && this.editor != null) {
								this.editor.destroy();
								this.editor = null;
							}
							this.$emit('book-event');
						}

					} else {
						this.$message({
							type: 'info',
							message: res.data.msg
						});
					}
				});
			},
			fun_del: async function() {
				await this.fun_check();
				// console.log('删除！');

				let postdata =
					'{"action":"' + 'data_delhtml_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.title +
					'","upfile_data":"' +
					base_encode(this.editor.txt.html()) +
					'","rowid":"' +
					this.main_id +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';

				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"Page_Action","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == '1') {
						// console.log(res.data);
						this.$message({
							type: 'success',
							message: res.data.msg
						});
					} else {
						this.$message({
							type: 'info',
							message: res.data.msg
						});
					}
				});

			},
			///附件处理 START//////////////////////////////////////////////////////////////////////////////
			fun_up_file_max: async function(file) {
				// console.log('开始执行上传文件=' + this.main_id);
				// // 大于1M，分段上传
				// console.log(file);
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				this.file_name = '';
				this.file_name = file.name;
				// this.file_name = file.name;
				this.file_type = '';
				this.file_type = file.type;
				this.file_size = 0;
				this.file_size = file.size;
				maxFileLength = file.size;
				// console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);
				// console.log('上传长度=' + file.size);

				this.element_loading = true;
				this.show_file = true;
				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}

					let temp_data = '';
					temp_data = file.slice(start, end); //文件切片
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						// console.log(res);
						if (res.status == 1) {
							this.file_up = file.name + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }
						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				let back = await this.fun_up_file_savepath();

				this.element_loading = false;
				// console.log(back);
				return back;
			},
			fun_up_file_block: async function(temp_data) {

				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"action":"' + 'save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.main_id +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {
					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {

				var postdata = "";

				postdata =
					'{"action":"' + 'save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					'","upfile_type":"' +
					this.file_type +
					'","upfile_size":"' +
					this.file_size +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","upfile_data":"' +
					'' +
					'","rowid":"' +
					this.main_id +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';

				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';

				let that = this;

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method,
						postdata
					).then(res => {

						res = JSON.parse(res);

						resolve(res)
					})
				});

			},
			fun_del_file: function(d) {
				// console.log(d.id + '=' + d.f_src);
				var postdata = "";
				postdata =
					'{"action":"' + 'file_del_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_path":"' +
					base_encode(d.f_src) +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					d.id +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						// console.log(res);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});



			},
			beforeDestroy() {
				// 销毁编辑器
				this.editor.destroy()
				this.editor = null
			}

		}
	}
</script>

<style lang="css" scoped="scoped">
	.editor-page {
		height: calc(100vh - 80px);
	}

	.editor-btn {
		display: inline-block;
		height: auto;
		width: 100%;
	}

	.toolbar,
	.edit-body {
		width: 800px;
	}

	.edit-body {
		height: calc(100vh - 180px);
		max-height: calc(100vh - 180px);

		overflow-y: auto;
	}




	img {
		width: 100%;
		display: block;
	}


	/* table 样式 */
	table {
		border-top: 1px solid #ccc;
		border-left: 1px solid #ccc;
	}

	table td,
	table th {
		border-bottom: 1px solid #ccc;
		border-right: 1px solid #ccc;
		padding: 3px 5px;
	}

	table th {
		border-bottom: 2px solid #ccc;
		text-align: center;
	}

	/* blockquote 样式 */
	blockquote {
		display: block;
		border-left: 8px solid #d0e5f2;
		padding: 5px 10px;
		margin: 10px 0;
		line-height: 1.4;
		font-size: 100%;
		background-color: #f1f1f1;
	}

	/* code 样式 */
	code {
		display: inline-block;
		*display: inline;
		*zoom: 1;
		background-color: #f1f1f1;
		border-radius: 3px;
		padding: 3px 5px;
		margin: 0 3px;
	}

	pre code {
		display: block;
	}

	/* ul ol 样式 */
	ul,
	ol {
		margin: 10px 0 10px 20px;
	}
</style>
